import { render, staticRenderFns } from "./ParticipantVisitsTable.vue?vue&type=template&id=380c719e&"
import script from "./ParticipantVisitsTable.vue?vue&type=script&lang=js&"
export * from "./ParticipantVisitsTable.vue?vue&type=script&lang=js&"
import style0 from "./ParticipantVisitsTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports